/**
 * @desc 新增请款
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.CostToPayRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentMaster/savePay`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
